const CONCILIATION_COMPANY_SESSION_KEY = 'conciliation.selectedCompanyId';

export const getStoredConciliationCompanyId = () => {
  try {
    const raw = sessionStorage.getItem(CONCILIATION_COMPANY_SESSION_KEY);
    if (!raw) return null;
    const n = Number(raw);
    return Number.isNaN(n) ? raw : n;
  } catch {
    return null;
  }
};

export const setStoredConciliationCompanyId = (companyId) => {
  try {
    if (companyId === null || companyId === undefined || companyId === '') {
      sessionStorage.removeItem(CONCILIATION_COMPANY_SESSION_KEY);
      return;
    }
    sessionStorage.setItem(CONCILIATION_COMPANY_SESSION_KEY, String(companyId));
  } catch {
    // ignore storage errors
  }
};

